import * as React from 'react';
import { FixedHeader as FixedHeaderComponent } from '../../components/FixedHeader';
import { useSelector } from 'react-redux';
import { newbuildingDisplayNameSelector, newbuildingUrlSelector } from '../../selectors/newbuilding';
import { FavoriteButton } from '../FavoriteButton';
import { ShareButton } from '../ShareButton';

export const FixedHeader = (): React.JSX.Element => {
  const name = useSelector(newbuildingDisplayNameSelector);
  const url = useSelector(newbuildingUrlSelector);

  return (
    <FixedHeaderComponent name={name} url={url} favoriteButton={<FavoriteButton />} shareButton={<ShareButton />} />
  );
};
